import { FormControl, MenuItem, Select, TextField, InputAdornment } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import React from "react";
import { JSONField } from "./Field/JSONField";

function propToType(str) {
    return str.replace(/\d+$/, '');
}

export const RenderInputField = ({ item, attr, onChange, disabled = false, fromType }) => {
    const style = {};
    const type = propToType(attr.attrType);

    const onFieldChange = (e) => {
        if (typeof onChange !== 'function') return;

        if (type === 'body') {
            return;
        } else if (type === 'integer') {
            onChange(parseInt(e?.target?.value), attr);
        } else if (type === 'float') {
            onChange(parseFloat(e?.target?.value), attr);
        } else if (type === 'boolean') {
            onChange(!!e?.target?.value, attr);
        } else if (type === 'datetime') {
            const date = new Date(e?.target?.value);
            const timestamp = date.getTime();
            onChange(timestamp, attr);
        }
        else if (type === 'date') {
            const date = new Date(e?.target?.value);
            const timestamp = date.getTime();
            onChange(timestamp, attr);
        }
        if (e?.target?.value) {
            onChange(e?.target?.value, attr);
        }
    };

    const renderTextField = (props) => (
        <TextField
            value={fromType ? '' : (item?.[attr.attrName] || '')}
            onChange={onFieldChange}
            disabled={disabled}
            fullWidth={true}
            style={style}
            // label={fromType ? (`item.${attr.attrName} ( ${attr?.encrypted ? 'encrypted ' : ''}${propToType(attr.attrType)} )`) : attr.label}
            label={fromType ? (`item.${attr.attrName} ( ${attr?.encrypted ? 'encrypted ' : ''}${attr.attrType} )`) : attr.label}
            placeholder={attr.placeholder}
            variant="outlined"
            InputProps={{
                endAdornment: attr.unit ? <InputAdornment position="end">{attr.unit}</InputAdornment> : null,
            }}
            {...props}
        />
    );

    switch (type) {
        case 'itemId':
            return renderTextField({type: "text"});
        case 'body':
            return <JSONField value={item?.[attr.attrName]} onChange={onChange} attr={attr} disabled={disabled} />;
        case 'integer':
            return renderTextField({type: "number"});
        case 'boolean':
            return (
                <FormControl style={style} variant="outlined" fullWidth={true}>
                    <InputLabel id="select-label">{attr.label}</InputLabel>
                    <Select
                        value={item?.[attr.attrName]}
                        onChange={onFieldChange}
                        disabled={disabled}
                        labelId="select-label"
                        label={attr.label}
                        placeholder={attr.placeholder}
                    >
                        <MenuItem value={true}>True</MenuItem>
                        <MenuItem value={false}>False</MenuItem>
                    </Select>
                </FormControl>
            );
        case 'float':
            return renderTextField({type: "number"});
        case 'date':
            return renderTextField({type: "date"});
        case 'datetime':
            return renderTextField({type: "datetime-local"});
        case 'text':
            return renderTextField({type: "text", multiline: true});
        case 'keyword':
            return renderTextField({type: "text"});
        default:
            return renderTextField({type: "text"});
    }
};